import { AbstractComponentController } from "../../helpers";

export class HeaderController extends AbstractComponentController {

    changeLanguage(langKey) {

        localStorage.setItem('lang', langKey);
        window.location.reload();
    }
}


export const HeaderComponent = {
    selector:   'appHeader',
    template:   require('./header.component.html'),
    controller: HeaderController
};


// WEBPACK FOOTER //
// ./src/app-modules/header/header.component.js